import { adj, f, m, type Pool } from './poolTypes.ts';

export const AR_POOL: Pool = {
  key: 'ar',
  animals: [
    ...['carpincho', 'yaguarete', 'hornero', 'condor', 'puma', 'nandu', 'guanaco', 'pinguino', 'tero', 'zorro', 'sapo',
      'colibri', 'caracol', 'delfin', 'elefante', 'jabali', 'ciervo', 'castor', 'flamenco', 'tucan', 'cardenal', 'benteveo',
      'chimango', 'carancho', 'aguara', 'oso', 'coati', 'tapir', 'huemul', 'pejerrey', 'surubi', 'camello', 'panda', 'koala',
      'lince', 'bufalo', 'toro', 'caballo', 'potro', 'gallo', 'conejo', 'pato'].map(m),
    ...['vizcacha', 'mulita', 'aguila', 'lechuza', 'garza', 'tortuga', 'iguana', 'llama', 'vicuna', 'chinchilla',
      'mariposa', 'hormiga', 'abeja', 'rana', 'nutria', 'foca', 'cebra', 'jirafa', 'pantera', 'leona', 'yarara', 'boa',
      'gaviota', 'paloma', 'calandria', 'corzuela', 'orca'].map(f),
  ],
  petForms: [
    ...['carpinchito', 'pumita', 'zorrito', 'sapito', 'lobito', 'osito', 'conejito', 'pajarito', 'pececito', 'patito',
      'potrillo'].map(m),
    ...['vizcachita', 'tortuguita', 'mariposita', 'hormiguita', 'abejita', 'ranita', 'palomita', 'lechucita'].map(f),
  ],
  adjectives: [
    'copado/copada', 'piola', 'groso/grosa', 'capo/capa', 'crack', 'genio/genia', 'master', 'zarpado/zarpada',
    'tremendo/tremenda', 'terrible', 'fachero/fachera', 'canchero/canchera', 'pillo/pilla', 'vivo/viva', 'rapido/rapida',
    'veloz', 'feliz', 'tranqui', 'relajado/relajada', 'dormilon/dormilona', 'comilon/comilona', 'matero/matera',
    'futbolero/futbolera', 'tanguero/tanguera', 'cumbiero/cumbiera', 'rockero/rockera', 'milonguero/milonguera',
    'folklorico/folklorica', 'criollo/criolla', 'gaucho/gaucha', 'valiente', 'guerrero/guerrera', 'invicto/invicta',
    'legendario/legendaria', 'epico/epica', 'magico/magica', 'dorado/dorada', 'celeste', 'azul', 'verde', 'rojo/roja',
    'violeta', 'brillante', 'sereno/serena', 'curioso/curiosa', 'sonador/sonadora', 'viajero/viajera',
    'fiestero/fiestera', 'bailarin/bailarina', 'cantor/cantora', 'goleador/goleadora', 'arquero/arquera',
    'gambeteador/gambeteadora', 'campeon/campeona', 'ninja', 'samurai', 'pirata', 'vikingo/vikinga', 'astronauta',
    'poeta', 'gamer', 'nerd', 'geek', 'salvaje', 'libre', 'noble', 'sabio/sabia', 'astuto/astuta', 'audaz', 'fuerte',
    'dulce', 'lindo/linda', 'bonito/bonita', 'alegre', 'risueno/risuena', 'loco/loca', 'atrevido/atrevida',
    'picaro/picara', 'travieso/traviesa', 'cebador/cebadora', 'asador/asadora', 'buenaonda', 'mistico/mistica',
    'cosmico/cosmica', 'estelar', 'fenomenal', 'barbaro/barbara', 'joya', 'fiera',
  ].map(adj),
  foods: [
    ...['asado', 'mate', 'alfajor', 'choripan', 'locro', 'chipa', 'helado', 'bizcochito', 'sanguche', 'pancho', 'chimichurri',
      'terere', 'flan', 'churro', 'pastelito', 'mantecol', 'cafecito', 'matambre', 'chorizo', 'quesillo', 'pionono',
      'turron', 'mani'].map(m),
    ...['empanada', 'milanesa', 'medialuna', 'factura', 'provoleta', 'humita', 'torta', 'tortilla', 'pizza', 'fugazzeta',
      'faina', 'pasta', 'picada', 'chocotorta', 'carbonada', 'rosca', 'galletita', 'tostada', 'gaseosa', 'yerba',
      'morcilla'].map(f),
  ],
  foodAdjectives: [
    'tibio/tibia', 'calentito/calentita', 'crocante', 'cremoso/cremosa', 'fresquito/fresquita', 'dulce',
    'tremendo/tremenda', 'feliz', 'copado/copada', 'piola', 'groso/grosa', 'zarpado/zarpada', 'barbaro/barbara',
    'dorado/dorada', 'cebado/cebada', 'casero/casera', 'criollo/criolla',
  ].map(adj),
  titles: {
    any: ['che', 'profe', 'tio', 'tia'],
    m: ['don', 'senor', 'doctor', 'el'],
    f: ['dona', 'senora', 'doctora', 'la'],
  },
  persons: [m('pibe'), f('piba'), m('chabon'), m('flaco'), f('flaca')],
  t5Titles: {
    m: ['rey', 'capo', 'crack', 'dueno', 'jefe', 'patron', 'maestro', 'genio', 'principe', 'pibe', 'senor'],
    f: ['reina', 'capa', 'duena', 'jefa', 'patrona', 'maestra', 'genia', 'princesa', 'piba', 'senora'],
  },
  t5Article: { m: 'del', f: 'de.la' },
  t5Things: {
    m: ['asado', 'mate', 'tango', 'cuarteto', 'folklore', 'rock', 'potrero', 'barrio', 'delta', 'sur', 'norte', 'litoral',
      'rio', 'choripan', 'alfajor', 'domingo', 'gol', 'bondi', 'subte', 'obelisco', 'campo', 'verano', 'chamame',
      'carnaval', 'fogon'],
    f: ['milonga', 'cumbia', 'pelota', 'esquina', 'pampa', 'patagonia', 'costa', 'sierra', 'empanada', 'suerte', 'cancha',
      'tribuna', 'gambeta', 'plaza', 'peatonal', 'ruta', 'fiesta', 'siesta', 'calle', 'luna'],
  },
  idioms: ['pibe.de.oro', 'barrilete.cosmico', 'che.pibe', 'capo.de.capos', 'rey.del.asado', 'el.mas.capo', 'la.mas.capa',
    'crack.total', 'fenomeno.total', 'vamos.los.pibes', 'rey.de.la.siesta'],
  regionals: [
    'porteno/portena', 'cordobes/cordobesa', 'rosarino/rosarina', 'mendocino/mendocina', 'tucumano/tucumana',
    'santafesino/santafesina', 'misionero/misionera', 'patagonico/patagonica', 'salteno/saltena',
    'correntino/correntina', 'entrerriano/entrerriana', 'chaqueno/chaquena', 'riojano/riojana', 'sanjuanino/sanjuanina',
    'jujeno/jujena', 'marplatense', 'platense', 'bonaerense', 'litoraleno/litoralena', 'pampeano/pampeana',
    'sureno/surena', 'norteno/nortena', 'argento/argenta', 'argentino/argentina', 'criollo/criolla', 'gaucho/gaucha',
    'fueguino/fueguina', 'neuquino/neuquina', 'rionegrino/rionegrina', 'formoseno/formosena',
    'santiagueno/santiaguena', 'catamarqueno/catamarquena', 'sanluiseno/sanluisena',
  ].map(adj),
  excluded: [
    // politics
    'milei', 'cristina', 'kuka', 'gorila', 'zurdo', 'facho', 'casta', 'libertario', 'peronista', 'kirchnerista', 'leon', 'topo',
    // slurs / sexual double meanings
    'gato', 'gata', 'boludo', 'pelotudo', 'gil', 'chorro', 'trucho', 'villero', 'cheto', 'negro', 'grasa', 'cabeza', 'gorra',
    'yegua', 'perro', 'perra', 'salame', 'nabo', 'pavo', 'ganso', 'burro', 'vaca', 'chancho', 'mono', 'rata', 'garca',
    'forro', 'concha', 'cola', 'culo', 'pija', 'pito', 'poronga', 'bolas', 'pelotas', 'puto', 'trolo', 'mogolico',
    'cornudo', 'cagon', 'gordo', 'gorda', 'nena', 'ballena',
    // club nicknames
    'gallina', 'bostero', 'xeneize', 'millonario', 'cuervo', 'pincha', 'canalla', 'lepra', 'sabalero', 'tomba', 'tatengue',
    'taladro', 'ciclon', 'globo', 'calamar', 'halcon', 'lobo', 'tiburon', 'tigre',
    // alcohol / gambling
    'fernet', 'birra', 'cerveza', 'vino', 'previa', 'joda', 'quiniela', 'bicho',
    // religion / real people
    'dios', 'diego', 'messi', 'dibu', 'scaloneta',
    // promises of winning
    'ganador', 'rico',
  ],
};
